import React from 'react';
import ThemeToggle from './ThemeToggle';

const Header = ({ user, onLogout }) => {
  return (
    <header className="fixed top-0 left-0 right-0 z-20 bg-white bg-opacity-95 backdrop-blur-lg border-b border-secondary-200 shadow-sm dark:bg-slate-900 dark:bg-opacity-95 dark:border-slate-700 dark:shadow-slate-900/20 transition-colors duration-300">
      <div className="max-w-[95%] mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Title */}
          <div className="flex items-center space-x-3">
            <img 
              src="/logo.png" 
              alt="Data Bing Bong" 
              className="h-8 w-auto"
            />
            <h1 className="text-xl font-bold text-gray-900 dark:text-white">
              Sales Analytics Dashboard
            </h1>
          </div>
          
          {/* User Controls */}
          <div className="flex items-center space-x-4">
            <ThemeToggle />
            
            {user && (
              <div className="flex items-center space-x-3">
                <div className="text-right">
                  <p className="text-sm font-medium text-gray-900 dark:text-white">
                    {user.name}
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    {user.email}
                  </p>
                </div>
                
                <button
                  onClick={onLogout}
                  className="px-4 py-2 text-sm font-medium text-white bg-red-500 hover:bg-red-600 rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
